import { render, staticRenderFns } from "./StatementCollect.vue?vue&type=template&id=7878ce66&scoped=true&"
import script from "./StatementCollect.vue?vue&type=script&lang=js&"
export * from "./StatementCollect.vue?vue&type=script&lang=js&"
import style0 from "./StatementCollect.vue?vue&type=style&index=0&id=7878ce66&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7878ce66",
  null
  
)

export default component.exports